<app-header></app-header>
<app-leftsidebar></app-leftsidebar>
<div class="common-page-main">
  <div class="common-herobanner">
    <img src="assets/images/cpbanner.png" alt="" />
  </div>
  <div class="right-sec common-right-sec right-slide">
    <div class="common-right-sec-bg">
      <div class="common-sec-heading">
        <h2>Terms of Service</h2>
        <div class="common-btn-sec">
          <a class="btn btn-dark" routerLink="/home">Back</a>
        </div>
      </div>
      <div class="common-content">
        <p><em>Last updated: 28 September 2026</em></p>

        <h5>1. Who we are</h5>
        <p>
          WorldTumbler is operated by <strong>Dovetail Ventures LLC</strong> ("WorldTumbler", "we", "us",
          "our"), a Texas limited liability company, 5900 Balcones Dr, Ste 100, Austin, TX 78731-4298. These
          Terms of Service ("Terms") are an agreement between you and Dovetail Ventures LLC and govern your
          use of the website at <a href="https://worldtumbler.com">worldtumbler.com</a> and every related
          service (together, the "Service"). By creating an account or using the Service you agree to these
          Terms and to our <a routerLink="/privacy-policy">Privacy Policy</a>. If you do not agree, please do
          not use the Service.
        </p>

        <h5>2. Your account</h5>
        <p>
          You must provide accurate information when you create an account and keep it up to date. You are
          responsible for keeping your login secure and for everything that happens under your account. Tell
          us straight away at <a href="mailto:support&#64;worldtumbler.com">support&#64;worldtumbler.com</a>
          if you think someone else has used it.
        </p>
        <p>
          If you are under 18, you may use the Service only with the involvement and permission of a parent or
          guardian, who agrees to these Terms on your behalf. Children under 13 may use the Service only
          through an account created and supervised by a parent, guardian or game master who is responsible
          for them, as described in our Privacy Policy.
        </p>

        <h5>3. The Service</h5>
        <p>
          WorldTumbler lets you build fantasy worlds, maps and settings, run and join games as a game master
          or player, write wiki entries, share in the community feed, and buy or sell content in the
          marketplace. We are always improving it, so features may be added, changed or removed. We will try
          to give notice of any change that materially reduces what a paid plan includes.
        </p>

        <h5>4. Subscriptions and purchases</h5>
        <p>
          Some features need a paid subscription or a one-off purchase. Prices are shown before you pay and
          payments are processed by Stripe; we never see or store your full card details. A subscription
          renews automatically at the end of each billing period until you cancel it. You can cancel at any
          time from your account; cancellation takes effect at the end of the period you have already paid
          for. Except where the law requires otherwise, payments are non-refundable, and we do not give
          refunds or credits for partly used periods.
        </p>
        <p>
          We may change prices for future billing periods. We will tell you before a price change affects
          your subscription, and you can cancel before it takes effect.
        </p>

        <h5>5. The marketplace</h5>
        <p>
          Creators ("vendors") can offer maps, assets and other content for sale in the marketplace. When
          you buy content, you buy it from the vendor under the licence the vendor states on the listing;
          unless the listing says otherwise, it is a personal, non-exclusive licence to use the content in
          your own games and worlds, not to resell or redistribute it.
        </p>
        <p>
          If you sell in the marketplace, you confirm that you own or have the right to sell everything you
          list, and you are responsible for your listings, the accuracy of their descriptions, any taxes due
          on your sales, and supporting your buyers. We charge the platform fee shown to you before you list,
          and pay out your earnings through our payment provider according to the payout terms shown in your
          vendor dashboard. We may remove listings, withhold payouts connected to fraud or infringement, or
          suspend selling privileges for breach of these Terms.
        </p>

        <h5>6. Your content</h5>
        <p>
          You keep ownership of the worlds, maps, text, images and other content you create or upload ("your
          content"). You give us a worldwide, non-exclusive, royalty-free licence to host, store, copy,
          display and process your content only as needed to run, show and improve the Service for you and
          the people you choose to share it with. This licence ends when you delete your content or account,
          except for copies kept in routine backups for a limited time or where the law requires us to keep
          them.
        </p>
        <p>
          You are responsible for your content and confirm you have the rights to it. Content you share
          publicly, in the community feed or in a game with others may be seen, and in some cases copied into
          their own games, by those people.
        </p>

        <h5>7. Acceptable use</h5>
        <p>You agree not to use the Service to:</p>
        <ul>
          <li>break the law or infringe anyone's intellectual property, privacy or other rights;</li>
          <li>harass, threaten, bully or impersonate others, or share hateful or sexually explicit content;</li>
          <li>share content that exploits or endangers children in any way;</li>
          <li>upload malware, or try to break, overload, probe or get unauthorised access to the Service;</li>
          <li>scrape the Service, or use bots or automated accounts, without our written permission;</li>
          <li>send spam, run scams, or manipulate reviews, ratings or marketplace sales.</li>
        </ul>
        <p>
          We may remove content, and suspend or close accounts, that break these rules. Report anything that
          concerns you to <a href="mailto:support&#64;worldtumbler.com">support&#64;worldtumbler.com</a>.
        </p>

        <h5>8. Our intellectual property</h5>
        <p>
          The Service itself — its software, design, logos, the WorldTumbler name and the content we create —
          belongs to Dovetail Ventures LLC or its licensors. These Terms do not give you any rights in it
          except the right to use the Service as intended.
        </p>

        <h5>9. Ending your use</h5>
        <p>
          You can stop using the Service and delete your account at any time. We may suspend or end your
          access if you break these Terms, if we are required to by law, or if we stop offering the Service;
          where we reasonably can, we will give notice and a chance to download your content first.
        </p>

        <h5>10. Disclaimers</h5>
        <p>
          The Service is provided "as is" and "as available". We do our best to keep it running and your
          content safe, but we do not promise that it will always be available, error-free or free of data
          loss, and you should keep your own copies of anything important. To the fullest extent the law
          allows, we disclaim all implied warranties, including merchantability, fitness for a particular
          purpose and non-infringement.
        </p>

        <h5>11. Limitation of liability</h5>
        <p>
          To the fullest extent the law allows, Dovetail Ventures LLC is not liable for any indirect,
          incidental, special, consequential or punitive damages, or for lost profits, data or goodwill,
          arising from your use of the Service. Our total liability for any claim relating to the Service is
          limited to the greater of the amount you paid us in the 12 months before the claim arose or
          US $50. Nothing in these Terms limits liability that cannot be limited by law.
        </p>

        <h5>12. Indemnity</h5>
        <p>
          You agree to defend and indemnify Dovetail Ventures LLC against claims, losses and costs (including
          reasonable legal fees) arising from your content, your marketplace sales, or your breach of these
          Terms or the law.
        </p>

        <h5>13. Governing law</h5>
        <p>
          These Terms are governed by the laws of the State of Texas, USA, without regard to conflict-of-law
          rules. Any dispute will be heard in the state or federal courts located in Travis County, Texas, and
          you and we consent to their jurisdiction. If you live in a country whose consumer laws give you
          rights that cannot be waived, those rights still apply.
        </p>

        <h5>14. Changes to these Terms</h5>
        <p>
          We may update these Terms. If a change is material, we will tell you by email or in the Service
          before it takes effect. Continuing to use the Service after that means you accept the new Terms.
        </p>

        <h5>15. Contact</h5>
        <p>
          Dovetail Ventures LLC, 5900 Balcones Dr, Ste 100, Austin, TX 78731-4298, USA ·
          <a href="mailto:support&#64;worldtumbler.com">support&#64;worldtumbler.com</a>
        </p>
      </div>
    </div>
  </div>
</div>
